import { Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

const InvoiceNumberTitle = ({ num }: { num: number | string }) => {
    return <Typography sx={{
        color: '#ffffff88',
    }}><FormattedMessage id="invoice.title" values={{ n: num }} /></Typography>;
};

export default InvoiceNumberTitle;